import { useQuery } from '@tanstack/react-query';

import { getUserDocument } from '@arrived/api_v2';
import { UserDocument, UserDocumentId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { userDocumentKeyFn } from './userDocuments.keys';

export function useUserDocumentQuery(userDocumentId: UserDocumentId, options?: UseQueryOptions<UserDocument>) {
  return useQuery(userDocumentKeyFn(userDocumentId), async () => getUserDocument(userDocumentId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
